import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import Dialog from '@/components/ui-bridge/core/Dialog';
import DialogContent from '@/components/ui-bridge/core/DialogContent';
import IconButton from '@/components/ui-bridge/core/IconButton';
import CloseIcon from '@/components/ui-bridge/icons/Close';
import PropTypes from 'prop-types';

import popupDocusign from '@/images/popup-docusign.png';
import popupMultipleDivergences from '@/images/popup-multiple-divergences.png';

const POPUP_IMAGES = {
  docusign: popupDocusign,
  divergences: popupMultipleDivergences,
};

class MarketingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
    };
  }

  handleShowDetails = () => {
    this.setState({ showDetails: true });
  };

  handleBackToMain = () => {
    this.setState({ showDetails: false });
  };

  handleClose = () => {
    this.setState({ showDetails: false });
    this.props.onClose();
  };

  render() {
    const { open, onBannerClick, typeBanner, urlRedirect } = this.props;
    const popupImage = POPUP_IMAGES[typeBanner] || POPUP_IMAGES.docusign;

    const handleBannerClick = () => {
      if (onBannerClick) {
        onBannerClick();
        return;
      }

      if (urlRedirect) {
        window.open(urlRedirect, '_blank');
      }
    };
    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        maxWidth="md"
        className="!w-fit !max-w-none !rounded-none !bg-transparent !shadow-none !overflow-visible"
        PaperProps={{
          className: '!w-fit !max-w-none !rounded-none !bg-transparent !shadow-none !overflow-visible',
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <DialogContent className="!bg-transparent p-0 pt-0">
          <div className="flex flex-col items-center justify-center p-0">
            <div className="relative mb-0 flex h-[90%] justify-center">
              <img
                src={popupImage}
                alt="Banner"
                className="h-auto max-h-[80vh] w-full max-w-[640px] cursor-pointer rounded-xl object-contain"
                onClick={handleBannerClick}
              />
              <IconButton
                onClick={this.handleClose}
                className="absolute right-1 top-1 z-[3] bg-[rgba(220,220,220,0.5)] p-1 text-white hover:bg-[rgba(220,220,220,0.4)]"
              >
                <CloseIcon className="h-6 w-6" />
              </IconButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

MarketingModal.propTypes = {
  typeBanner: PropTypes.oneOf(['docusign', 'divergences']),
  urlRedirect: PropTypes.string,
  onBannerClick: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(MarketingModal);
